export default __webpack_public_path__ + "static/media/starmap.589fa85c.png";